import { vuexEventPathGenerator } from '@/utils';
import { initState } from './state';
export const mutationType = {
    DIALOG_OPEN: 'DIALOG_OPEN',
    DIALOG_CLOSE: 'DIALOG_CLOSE',
    AREA_DIALOG_OPEN: 'AREA_DIALOG_OPEN',
    AREA_DIALOG_CLOSE: 'AREA_DIALOG_CLOSE',
    SELECTED_AREA: 'SELECTED_AREA',
    GET_DELIVERY_CHARGE_LIST: 'GET_DELIVERY_CHARGE_LIST',
    SET_STORE_DETAIL: 'SET_STORE_DETAIL',
    SET_PAGE_NUMBER: 'SET_PAGE_NUMBER',
    RESET: 'RESET',
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    CHECKED_LIST: 'CHECKED_LIST',
    UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
    SET_FORM: 'SET_FORM',
    SET_ORIGIN_FORM: 'SET_ORIGIN_FORM',
    IS_EDIT: 'IS_EDIT',
    SELECTED_ITEM: 'SELECTED_ITEM',
    RESET_FORM_VALIDATION: 'RESET_FORM_VALIDATION',
    SET_TOGGLE_FORM: 'SET_TOGGLE_FORM',
};
export const deliveryChargeMutationType = vuexEventPathGenerator(mutationType, 'deliveryChargeDialog');
const mutations = {
    [mutationType.RESET_FORM_VALIDATION]() {
        // subscribe only
    },
    [mutationType.SELECTED_ITEM](state, value = null) {
        state.selectedItem = value;
    },
    [mutationType.IS_EDIT](state, value) {
        state.isEdit = value;
    },
    [mutationType.SET_FORM](state, value) {
        state.formData = value;
    },
    [mutationType.SET_ORIGIN_FORM](state, value) {
        state.originFormData = value;
    },
    [mutationType.UPDATE_FORM_DATA](state, { key, value }) {
        state.formData[key] = value;
    },
    [mutationType.CHECKED_LIST](state, payload = []) {
        state.checkedList = payload;
    },
    [mutationType.SET_FILTER_OPTION]({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
    [mutationType.RESET](state) {
        Object.assign(state, initState());
    },
    [mutationType.DIALOG_OPEN](state) {
        state.isDeliveryChargeDialogOpen = true;
    },
    [mutationType.DIALOG_CLOSE](state) {
        state.isDeliveryChargeDialogOpen = false;
    },
    [mutationType.AREA_DIALOG_OPEN](state) {
        state.isAreaDialogOpen = true;
    },
    [mutationType.AREA_DIALOG_CLOSE](state) {
        state.isAreaDialogOpen = false;
    },
    [mutationType.SELECTED_AREA](state, payload = null) {
        state.selectedArea = payload;
    },
    [mutationType.GET_DELIVERY_CHARGE_LIST](state, { list, paginationData }) {
        state.deliveryChargeList = list;
        state.paginationData = paginationData;
    },
    [mutationType.SET_STORE_DETAIL](state, storeDetail) {
        state.storeDetail = storeDetail;
    },
    [mutationType.SET_PAGE_NUMBER](state, pageNumber) {
        state.paginationData.pageNumber = pageNumber;
    },
    [mutationType.SET_TOGGLE_FORM](state, flag) {
        state.toggleForm = flag;
    },
};
export default mutations;
